import React from 'react';
import styled from "styled-components";
import GridContainer from "@/components/common/GridContainer";

const Wrapper = styled(GridContainer)`
	min-height: 30svh;
    --bg-size: 25%;
`

const Skeleton = () => {
	// console.log('skeleton');
	return (
		<Wrapper className="loading"/>
	);
};

export default Skeleton;
